import { lazy, Suspense } from 'react';
import { PAPERS } from './data/papersData';

// Lazy load page components
const Header = lazy(() => import('./components/Header'));
const Home = lazy(() => import('./components/Home'));
const Research = lazy(() => import('./components/Research'));
const Teaching = lazy(() => import('./components/Teaching'));
const Conferences = lazy(() => import('./components/Conferences'));
const Awards = lazy(() => import('./components/Awards'));
const Resources = lazy(() => import('./components/Resources'));
const NotFound = lazy(() => import('./components/NotFound'));
const Footer = lazy(() => import('./components/Footer'));

// Loading component for Suspense
const Loading = () => (
  <div className="loading-container">
    <div className="loader">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <p className="loading-text">Loading...</p>
  </div>
);

// Layout wrapper component
const PageLayout = ({ children }) => (
  <>
    <Suspense >
      <Header />
    </Suspense>

    <div className="content-area">
      <main className="main-content">
        {children}
      </main>
    </div>

    <Suspense >
      <Footer />
    </Suspense>
  </>
);

// Route definitions with metadata
const routes = [
  {
    path: '/',
    name: 'Home',
    component: (
      <PageLayout>
        <Suspense fallback={<Loading />}>
          <Home />
        </Suspense>
      </PageLayout>
    ),
    exact: true,
    color: 'var(--home-color)',
    icon: 'fa-home',
    meta: {
      title: 'Symeon Taipliadis',
      description: 'PhD Candidate in Economics at University of Florida specializing in macro-finance, monetary policy, and behavioral economics'
    }
  },
  {
    path: '/research',
    name: 'Research',
    component: (
      <PageLayout>
        <Suspense fallback={<Loading />}>
          <Research papers={PAPERS} />
        </Suspense>
      </PageLayout>
    ),
    color: 'var(--research-color)',
    icon: 'fa-book',
    meta: {
      title: 'Research | Symeon Taipliadis',
      description: 'Research papers and working papers'
    }
  },
  {
    path: '/teaching',
    name: 'Teaching',
    component: (
      <PageLayout>
        <Suspense fallback={<Loading />}>
          <Teaching />
        </Suspense>
      </PageLayout>
    ),
    color: 'var(--teaching-color)',
    icon: 'fa-chalkboard-teacher',
    meta: {
      title: 'Teaching | Symeon Taipliadis',
      description: 'Teaching experience and positions'
    }
  },
  {
    path: '/conferences',
    name: 'Conferences',
    component: (
      <PageLayout>
        <Suspense fallback={<Loading />}>
          <Conferences />
        </Suspense>
      </PageLayout>
    ),
    color: 'var(--conferences-color)',
    icon: 'fa-users',
    meta: {
      title: 'Conferences | Symeon Taipliadis',
      description: 'Conferences, workshops, and seminars'
    }
  },
  {
    path: '/awards',
    name: 'Awards',
    component: (
      <PageLayout>
        <Suspense fallback={<Loading />}>
          <Awards />
        </Suspense>
      </PageLayout>
    ),
    color: 'var(--awards-color)',
    icon: 'fa-award',
    meta: {
      title: 'Awards | Symeon Taipliadis',
      description: 'Awards and honors'
    }
  },
  {
    path: '/resources',
    name: 'Resources',
    component: (
      <PageLayout>
        <Suspense fallback={<Loading />}>
          <Resources />
        </Suspense>
      </PageLayout>
    ),
    icon: 'fa-book',
    color: 'var(--resources-color)',
    meta: {
      title: 'Resources | Symeon Taipliadis',
      description: 'Academic and professional resources'
    }
  },
  // 404 Not Found Route (Catch All)
  {
    path: '*',
    name: 'NotFound',
    component: (
      <PageLayout>
        <Suspense fallback={<Loading />}>
          <NotFound />
        </Suspense>
      </PageLayout>
    ),
    icon: 'fa-exclamation-triangle',
    color: 'var(--home-color)',
    meta: {
      title: '404 - Page Not Found | Symeon Taipliadis',
      description: 'The page you were looking for could not be found'
    }
  }
];

export default routes;
